import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import { action } from 'satcheljs/lib/legacy';
import PersonaType from 'owa-service/lib/contract/PersonaType';

const DEFAULT_MAX_RESULTS = 20;
const LEGACY_ROUTING_TYPE = 'EX';

export default action('processFindPeopleResult')(function processFindPeopleResult(
    resultList: FindRecipientPersonaType[],
    responseMessage: FindPeopleResponseMessage,
    appendResults: boolean,
    maxResults?: number
) {
    if (responseMessage.ResponseClass == 'Success' && responseMessage.ResultSet) {
        maxResults = maxResults ? maxResults : DEFAULT_MAX_RESULTS;
        maxResults = appendResults ? maxResults - resultList.length : maxResults;
        maxResults =
            responseMessage.ResultSet.length > maxResults
                ? maxResults
                : responseMessage.ResultSet.length;
        let personaTypeSet: FindRecipientPersonaType[] = [];
        for (let i = 0; i < maxResults; i++) {
            let result = responseMessage.ResultSet[i];
            if (result.EmailAddress) {
                personaTypeSet.push({
                    EmailAddress: getEmailAddress(result.EmailAddress),
                    PersonaId: result.PersonaId,
                    ADObjectId: result.ADObjectId,
                    PersonaTypeString: result.PersonaTypeString,
                    DisplayName: result.DisplayName,
                });
            } else if (result.PersonaTypeString == 'ImplicitGroup') {
                personaTypeSet.push({
                    EmailAddress: getImplicitGroupEmailAddress(result),
                    PersonaId: result.PersonaId,
                    ADObjectId: result.ADObjectId,
                    Members: result.Members,
                    PersonaTypeString: result.PersonaTypeString,
                    DisplayName: result.DisplayName,
                });
            }
        }

        if (appendResults) {
            resultList.push(...personaTypeSet);
        } else {
            resultList.splice(0, resultList.length, ...personaTypeSet);
        }
    } else {
        throw new Error('Response resultSet should not be null');
    }
});

let getEmailAddress = (emailAddress: EmailAddressWrapper): EmailAddressWrapper => {
    if (
        emailAddress.RoutingType &&
        emailAddress.RoutingType.toUpperCase() === LEGACY_ROUTING_TYPE
    ) {
        return {
            ...emailAddress,
            EmailAddress: emailAddress.OriginalDisplayName,
        } as EmailAddressWrapper;
    }

    return emailAddress;
};

let getImplicitGroupEmailAddress = (emailAddressData: PersonaType): EmailAddressWrapper => {
    return {
        EmailAddress: emailAddressData.FeedbackId,
        OriginalDisplayName: emailAddressData.FeedbackId,
        Name: emailAddressData.DisplayName,
        MailboxType: 'GroupMailbox',
        RoutingType: 'SMTP',
    } as EmailAddressWrapper;
};
